import React from "react";
import "./SkeletonProfile.css";

const SkeletonProfile = () => {
  return (
    <div className="skeleton-profile-container">
      {/* Left Panel Skeleton */}
      <div className="skeleton-left-panel">
        {/* Profile Card Skeleton */}
        <div className="skeleton-card">
          {/* Logo */}
          <div className="skeleton-logo skeleton-box" />
          {/* Party Name */}
          <div className="skeleton-party-name skeleton-box" />

          {/* Address */}
          <div className="skeleton-address-row">
            <div className="skeleton-address-icon skeleton-box" />
            <div className="skeleton-address-content">
              <div className="skeleton-address-label skeleton-box" />
              <div className="skeleton-address-text skeleton-box" />
            </div>
          </div>

          {/* Document Rows */}
          {[1, 2, 3].map((i) => (
            <div className="skeleton-doc-row" key={i}>
              <div className="skeleton-doc-label skeleton-box" />
              <div className="skeleton-doc-status skeleton-box" />
            </div>
          ))}

          {/* Lock Button */}
          <div className="skeleton-lock-button skeleton-box" />
          <div className="skeleton-lock-note skeleton-box" />
        </div>

        {/* Bank Card Skeleton */}
        <div className="skeleton-card">
          <div className="skeleton-bank-title skeleton-box" />
          {[1, 2, 3].map((i) => (
            <div className="skeleton-doc-row" key={i}>
              <div className="skeleton-doc-label skeleton-box" />
              <div className="skeleton-doc-status skeleton-box" />
            </div>
          ))}
        </div>
      </div>

      {/* Right Panel Skeleton */}
      <div className="skeleton-right-panel">
        {/* Refresh Button */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="skeleton-refresh-btn skeleton-box" />
        </div>

        {/* Anggota Section */}
        <div className="skeleton-section">
          <div className="skeleton-section-header">
            <div className="skeleton-section-title skeleton-box" />
          </div>
          {[1, 2, 3, 4].map((i) => (
            <div className="skeleton-row" key={i}>
              <div className="skeleton-row-label skeleton-box" />
              <div className="skeleton-row-value skeleton-box" />
            </div>
          ))}
        </div>

        {/* Kepengurusan Section */}
        <div className="skeleton-section">
          <div className="skeleton-section-header">
            <div className="skeleton-section-title skeleton-box" />
          </div>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
            <div className="skeleton-row" key={i}>
              <div className="skeleton-row-label skeleton-box" />
              <div className="skeleton-row-value skeleton-box" />
            </div>
          ))}
        </div>

        {/* Lampiran PKPU Section */}
        <div className="skeleton-section">
          <div className="skeleton-section-header">
            <div className="skeleton-section-title skeleton-box" />
          </div>
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <div className="skeleton-row" key={i}>
              <div className="skeleton-row-label skeleton-box" />
              <div className="skeleton-row-value skeleton-box" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonProfile;
